import { pathEq } from 'ramda'

import { useReplies } from '../../_load/ServiceOrderLoader'

export const usePendenciesReplies = () => {
  const replies = useReplies()
  return replies.filter(pathEq(['question', 'type', 'name'], 'pending'))
}
